import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { getLowStockSlice } from "../../../store/slices/stockInventorySlice";
import { getAllClinic } from "../../../store/slices/clinicSlice";
const LowStockDropdown = () => {
  const dispatch = useDispatch();
  const { lowStock } = useSelector((state) => state.stockInventory);
  const token = useSelector((state) => state.auth.token);
  const clinicInfo = useSelector((state) => state.clinic.clinicInfo);
  const clinicId =clinicInfo?.[0]?.clinicId || null;

  useEffect(() => {
    dispatch(getAllClinic({ clinicId, token }));
  }, [dispatch, clinicId, token]);

  useEffect(() => {
    if (clinicId && token) {
      dispatch(
        getLowStockSlice({
          clinicId,
          token,
        })
      );
    }
  }, [dispatch, token, clinicId]);


  return (
    <Dropdown as="li" className="nav-item dropdown notification_dropdown">
      <Dropdown.Toggle as="div" className="nav-link  i-false">
        <svg
          width={26}
          height={26}
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.75 14.8385V12.0463C21.7471 9.88552 20.9385 7.80353 19.4821 6.20735C18.0258 4.61116 16.0264 3.61555 13.875 3.41516V1.625C13.875 1.39294 13.7828 1.17038 13.6187 1.00628C13.4546 0.842187 13.2321 0.75 13 0.75C12.7679 0.75 12.5454 0.842187 12.3813 1.00628C12.2172 1.17038 12.125 1.39294 12.125 1.625V3.41534C9.97361 3.61572 7.97429 4.61131 6.51794 6.20746C5.06159 7.80361 4.25291 9.88555 4.25 12.0463V14.8383C3.26257 15.0412 2.37529 15.5784 1.73774 16.3593C1.10019 17.1401 0.751339 18.1169 0.75 19.125C0.750764 19.821 1.02757 20.4882 1.51969 20.9803C2.01181 21.4724 2.67904 21.7492 3.375 21.75H8.71346C8.91521 22.738 9.45205 23.6259 10.2331 24.2636C11.0142 24.9013 11.9916 25.2497 13 25.2497C14.0084 25.2497 14.9858 24.9013 15.7669 24.2636C16.548 23.6259 17.0848 22.738 17.2865 21.75H22.625C23.321 21.7492 23.9882 21.4724 24.4803 20.9803C24.9724 20.4882 25.2492 19.821 25.25 19.125C25.2486 18.117 24.8998 17.1402 24.2622 16.3594C23.6247 15.5786 22.7374 15.0414 21.75 14.8385ZM6 12.0463C6.00232 10.2113 6.73226 8.45223 8.02974 7.15474C9.32723 5.85726 11.0863 5.12732 12.9212 5.125H13.0788C14.9137 5.12732 16.6728 5.85726 17.9703 7.15474C19.2677 8.45223 19.9977 10.2113 20 12.0463V14.75H6V12.0463ZM13 23.5C12.4589 23.4983 11.9316 23.3292 11.4905 23.0159C11.0493 22.7026 10.716 22.2604 10.5363 21.75H15.4637C15.284 22.2604 14.9507 22.7026 14.5095 23.0159C14.0684 23.3292 13.5411 23.4983 13 23.5ZM22.625 20H3.375C3.14298 19.9999 2.9205 19.9076 2.75644 19.7436C2.59237 19.5795 2.50014 19.357 2.5 19.125C2.50076 18.429 2.77757 17.7618 3.26969 17.2697C3.76181 16.7776 4.42904 16.5008 5.125 16.5H20.875C21.571 16.5008 22.2382 16.7776 22.7303 17.2697C23.2224 17.7618 23.4992 18.429 23.5 19.125C23.4999 19.357 23.4076 19.5795 23.2436 19.7436C23.0795 19.9076 22.857 19.9999 22.625 20Z"
            fill="#36C95F"
          />
        </svg>
        {lowStock?.length > 0 && (
          <span className="badge light text-white bg-primary">
            {lowStock?.length}
          </span>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu
        align="end"
        className="mt-1 p-3"
        style={{ minWidth: "300px" }}
      >
        <h6 className="dropdown-header">Low Stock Items</h6>

        {lowStock && lowStock.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-sm table-bordered mb-2">
              <thead className="thead-light">
                <tr>
                  <th>Medicine Name</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {lowStock?.map((item, index) => (
                  <tr key={index}>
                    <td>{item?.name}</td>
                    <td>{item?.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="dropdown-item text-muted">No low stock</div>
        )}

        <Link className="all-notification d-block text-center mt-2" to="#">
          See all notifications <i className="ti-arrow-right" />
        </Link>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LowStockDropdown;
